@if (data() && data().type) {
  <div
    [ngClass]="{
      'fixed inset-0 bg-dark-900/50 dark:bg-dark-900/90 z-40': active(),
    }"></div>
  <div class="z-50 absolute h-screen w-screen top-0 pointer-events-none overflow-clip">
    <!-- Drawer -->
    @if (data().type === 'drawer') {
      <div
        class="pointer-events-auto transition-transform translate-x-0 w-[400px] max-w-screen bg-white shadow-2xl h-screen absolute top-0 right-0"
        [class.translate-x-full]="!active()">
        <ng-template *ngTemplateOutlet="content" />
      </div>
    }

    <!-- Dialog -->
    @if (data().type === 'dialog') {
      <div
        [class]="
          'pointer-events-auto transition-opacity w-[600px] p-8 max-w-screen max-h-screen bg-white dark:bg-dark-700 dark:text-dark-100 shadow-2xl rounded absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ' +
          data().classes
        "
        [class.opacity-0]="!active()">
        <ng-template *ngTemplateOutlet="content" />
      </div>
    }
  </div>
}
<ng-template #content>
  <ng-container #dynamicSection />
</ng-template>
